import React from "react";
import ArrowRight from "../../../../assets/images/app/arrow-right-white.png";
import styles from "./OverviewCard.module.css";

interface Props {
    value: string | number;
    label: string;
    icon: string;
    size: number;
    onShowPublications: () => void;
}

const OverviewCard: React.FC<Props> = ({ value, label, icon, size, onShowPublications }) => {
    return (
        <div className={styles.card}>
            <div className={styles.content}>
                <div className={styles.top}>
                    <span className={styles.value}>{value}</span>
                    <img src={icon} alt="" height={size || 25} />
                </div>
                <div className={styles.labelBox}>
                    <div className={styles.label} dangerouslySetInnerHTML={{ __html: label }} />
                    {label === "Nombre de<br/>publications" && <div className={styles.arrowBox} onClick={onShowPublications}>
                        <img src={ArrowRight} height={20} />
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default OverviewCard;
